<template>
<v-btn large :text="card" :color="color" type="submit" :loading="saving" :disabled="disabled"><v-icon v-if="!wizard" left>{{ icon }}</v-icon>{{ textInt }}<v-icon v-if="wizard" right>$next</v-icon></v-btn>
</template>
<script>
export default {
    name: 'SaveButton',
    props: {
        saving: { type: Boolean },
        text: { type: String },
        icon: { type: String, default: '$save'},
        wizard: { type: Boolean },
        disabled: { type: Boolean },
        card: { type: Boolean },
        color:  { type: String, default: 'primary' }
    },
    computed: {
        textInt() {
            if(this.text) {
                return this.text;
            } else if(this.wizard) {
                return this.$t('form.next');
            } else {
                return this.$t('form.save');
            }
        }
    }
}
</script>